module.exports = __webpack_public_path__ + "img/fixastar.64d350db.webp";